const languages = ["de", "en", "es", "fr", "it", "nl"];

export default languages;
